import React from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { useSiteData } from '../data/SiteDataContext';

function CategoryNav({ onNavigate }) {
    const { categories } = useSiteData();
    const location = useLocation();
    const params = useParams();

    const currentSlug = location.pathname.startsWith('/category/')
        ? (params.slug || location.pathname.split('/')[2] || '')
        : '';

    return (
        <nav className="category-nav" aria-label="Article categories">
            {categories.map((category) => (
                <Link
                    key={category.id}
                    to={`/category/${category.id}`}
                    className={category.id === currentSlug ? 'current-cat' : ''}
                    onClick={onNavigate}
                >
                    {category.label}
                    <span className="cat-count">{category.count}</span>
                </Link>
            ))}
        </nav>
    );
}

export default CategoryNav;
